import { create } from 'zustand'

interface FilterAndSearchStore {
    filterId: number | null
    changeFilter: (filter: number | null) => void
    searchTerm: { query: string; category: string }
    setSearchTerm: (searchTerm: { query: string; category: string }) => void
}
export const useFilterAndSearchStore = create<FilterAndSearchStore>()(set => ({
    filterId: null,
    changeFilter: filterId => set(() => ({ filterId })),
    searchTerm: { query: '', category: '' },
    setSearchTerm: searchTerm => set(() => ({ searchTerm }))
}))
